import API from '../api'
import getUrl from './paths'
import convertPagableData from '../convertPagableData'

export const getCategories = (page = 0, size = 1000, commodityFilter, sourceFilter = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getCategories, { page, size, commodityFilter, sourceFilter })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getCategoryById = (categoryId, source = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getCategoryById, { categoryId, source })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getProductByCategory = (categoryId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProductOfCategory, { categoryId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getAllProducts = (page = 0, searchFilter = { productNameFilter: '' }) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProducts, { page, ...searchFilter })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const getProductById = (productId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProductById, { productId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const getAllBrandApi = (page = 0, size = 100, filters) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllBrand, { page, size, ...filters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
	})

export const fetchGetTopCategories = (commodityName = null, orgId = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getTopCategories, { commodityName, orgId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
